import { Grid, GridColumn } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import PaymentHistoryStore from '../../../stores/PaymentHistoryStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import { formatAsCurrency } from '../../../util/FormatUtil';

interface IPeriodAmountsGridProps {
  translateStore?: ITranslateStore;
  paymentHistoryStore?: PaymentHistoryStore;
  amountsFontStyle: string;
}

@inject('translateStore', 'paymentHistoryStore')
@observer
export default class PeriodAmountsGrid extends React.Component<IPeriodAmountsGridProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const store = this.props.paymentHistoryStore;

    return (
      <Grid>
        <GridColumn width={['xs-6', 'sm-6', 'md-3', 'lg-2']}>
          <p>{translate('payment-history.invoice-total-amount')}</p>
          <p className={`text-bold ${this.props.amountsFontStyle}`} id="payment-history-invoice-total-amount">
            {formatAsCurrency(store.totalInvoiceAmount)}
          </p>
        </GridColumn>
        <GridColumn width={['xs-6', 'sm-6', 'md-3', 'lg-2']}>
          <p>{translate('payment-history.receipt-total-amount')}</p>
          <p className={`text-bold ${this.props.amountsFontStyle}`} id="payment-history-receipt-total-amount">
            {formatAsCurrency(store.totalReceiptPaidAmount)}
          </p>
        </GridColumn>
        <GridColumn width={['xs-6', 'sm-6', 'md-3', 'lg-2']}>
          <p>{translate('payment-history.transactions.opening-balance')}</p>
          <p className={`text-bold ${this.props.amountsFontStyle}`} id="payment-history-transactions-opening-balance">
            {formatAsCurrency(store.openingBalance)}
          </p>
        </GridColumn>
        <GridColumn width={['xs-6', 'sm-6', 'md-3', 'lg-2']}>
          <p>{translate('payment-history.transactions.closing-balance')}</p>
          <p className={`text-bold ${this.props.amountsFontStyle}`} id="payment-history-transactions-closing-balance">
            {formatAsCurrency(store.closingBalance)}
          </p>
        </GridColumn>
      </Grid>
    );
  }
}
